import Vue from 'vue';
import DeviceFavorite from '@/components/devices-template/DeviceFavorite';
import DeviceSensorTime from '@/components/devices-template/DeviceSensorTime';
import DeviceSwitchEnable from '@/components/devices-template/DeviceSwitchEnable';
import DeviceSwitchDisabled from '@/components/devices-template/DeviceSwitchDisabled';
import DeviceTitle from '@/components/devices-template/DeviceTitle';
import DeviceStatus from '@/components/devices-template/DeviceStatus';
import TimeField from "@/components/scenarios/form/TimeField";

Vue.component('device-favorite', DeviceFavorite);
Vue.component('device-sensor-time', DeviceSensorTime);
Vue.component('device-switch-enable', DeviceSwitchEnable);
Vue.component('device-switch-disabled', DeviceSwitchDisabled);
Vue.component('device-title', DeviceTitle);
Vue.component('device-status', DeviceStatus);
Vue.component('time-field', TimeField);